<script setup>
const props = defineProps({
  // { value: string, count: number }
  rating: { type: Object, default: () => ({ value: '4.8', count: 0 }) },
  // Array of [quote, name, role, colorHex]
  reviews: { type: Array, default: () => [] }
})

const ratingCount = computed(() => Number(props.rating?.count || 0).toLocaleString('en-US'))
</script>

<template>
  <section class="block tight">
    <div class="wrap">
      <div class="sec-h"><h2>Loved by creators worldwide</h2></div>
      <div class="rating-head" v-if="rating">
        <span class="stars">★★★★★</span>
        <span class="score">{{ rating.value }} / 5</span>
        <span class="count">based on {{ ratingCount }}+ ratings</span>
      </div>
      <div class="reviews">
        <div class="rev-card" v-for="(rev, i) in reviews" :key="i">
          <div class="rs">★★★★★</div>
          <p>{{ rev[0] }}</p>
          <div class="who">
            <span class="av" :style="{ background: rev[3] }">{{ rev[1] && rev[1][0] }}</span>
            <span>
              <span class="nm">{{ rev[1] }}</span><br />
              <span class="rl">{{ rev[2] }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
